import React, { Fragment } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserData, loadCompanyLogin, setUser } from "../../redux/actions";

const CompanySelectionModal = ({ tokenList = [], onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toggleCompany = async (company_user_id) => {
    try {
      const result = await loadCompanyLogin(company_user_id);

      if (result?.token) {
        localStorage.setItem("auth_token", result.token);

        // ✅ Ensure token is available before proceeding
        await new Promise((resolve) => setTimeout(resolve, 100)); // Small delay to ensure cookie is set

        if (localStorage.getItem("auth_token")) {
          const user_data = await fetchUserData();

          if (user_data?.message) {
            toast.error(user_data?.message);
          } else {
            localStorage.setItem("region", user_data?.company?.currency?.value);
            dispatch(setUser(user_data));

            navigate("/self-service/dashboard");
            toast.success("You have been signed in successfully!");
          }
        }
      } else {
        console.log("No token received.");
      }
    } catch (error) {
      console.log(error);
    }
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content ">
        <button className="close-btn" onClick={onClose}>
          &times;
        </button>
        <h3 className="text-blue">Choose the company</h3>
        <span className="p-5">
          Please select which company you wish to use.
        </span>

        <div className="flex w-full flex-col gap-y-4 overflow-y-auto">
          {tokenList.map((company, index) => (
            <Fragment key={index}>
              <div className="mb-10 h-px w-full bg-medium-grey mt-10" />

              <Link
                className="modal-link p-10"
                onClick={() => toggleCompany(company?.id)}
              >
                {company?.name + " - " + company?.company?.name}
              </Link>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanySelectionModal;
